import { Extension } from "@tiptap/core";
import { TextSelection } from "@tiptap/pm/state";

export const TableCellSelectAll = Extension.create({
  name: "tableCellSelectAll",

  addKeyboardShortcuts() {
    return {
      "Mod-a": ({ editor }) => {
        const { state } = editor;
        const { $from } = state.selection;

        // Walk up from the current position to find a tableCell or tableHeader
        for (let depth = $from.depth; depth > 0; depth--) {
          const node = $from.node(depth);
          if (
            node.type.name === "tableCell" ||
            node.type.name === "tableHeader"
          ) {
            const start = $from.start(depth);
            const end = $from.end(depth);

            editor.view.dispatch(
              state.tr.setSelection(
                TextSelection.create(state.doc, start, end)
              )
            );
            return true;
          }
        }

        return false;
      }
    };
  }
});
